import { render, staticRenderFns } from "./viewFooter.vue?vue&type=template&id=0d4f8cad&scoped=true&"
import script from "./viewFooter.vue?vue&type=script&lang=js&"
export * from "./viewFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4f8cad",
  null
  
)

export default component.exports